import './LoadingDots.scss';

import React from 'react';

export interface LoadingDotsProps {
	height?: number;
}

export const LoadingDots: React.FC<LoadingDotsProps> = ({ height = 160 }) =>
	<div className='loading-dots'>
		<svg
			viewBox='0 0 200 200'
			xmlns='http://www.w3.org/2000/svg'>
			<circle
				cx='40'
				cy={ height }
				fill='currentColor'
				r='15'
				stroke='currentColor'
				strokeWidth='15'>
				<animate
					attributeName='opacity'
					begin='-.4s'
					calcMode='spline'
					dur='2s'
					keySplines='.5 0 .5 1;.5 0 .5 1'
					repeatCount='indefinite'
					values='1;0;1' />
			</circle>
			<circle
				cx='100'
				cy={ height }
				fill='currentColor'
				r='15'
				stroke='currentColor'
				strokeWidth='15'>
				<animate
					attributeName='opacity'
					begin='-.2s'
					calcMode='spline'
					dur='2s'
					keySplines='.5 0 .5 1;.5 0 .5 1'
					repeatCount='indefinite'
					values='1;0;1' />
			</circle>
			<circle
				cx='160'
				cy={ height }
				fill='currentColor'
				r='15'
				stroke='currentColor'
				strokeWidth='15'>
				<animate
					attributeName='opacity'
					begin='0s'
					calcMode='spline'
					dur='2s'
					keySplines='.5 0 .5 1;.5 0 .5 1'
					repeatCount='indefinite'
					values='1;0;1' />
			</circle>
		</svg>
	</div>;
